







































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { FinanceInfo, Company } from '@/utils/Interfaces'
import InputNumber from '@/components/InputNumber.vue'
import InputSelect from '@/components/InputSelect.vue'
import NhapLieuCtyTTTaiChinhInputs from './NhapLieuCtyTTTaiChinhInputs.vue'

function getNewFinanceInfo (company: Company['id'], year: number): FinanceInfo {
  const newFinanceInfo: FinanceInfo = {
    company,
    year,
  }
  return newFinanceInfo
}

@Component({
  components: {
    InputNumber,
    InputSelect,
    NhapLieuCtyTTTaiChinhInputs,
  }
})
export default class NhapLieuCtyTTTaiChinh extends Vue {
  @Prop() readonly company!: Company
  @Prop(Array) readonly financeInfos!: Array<FinanceInfo>

  show = true
  addYearMenu = false
  removeYearMenu = false

  year = (new Date).getFullYear() - 1

  get years (): Array<number> {
    const years = this.financeInfos.map(info => info.year)
    return years
  }

  yearToAdd = (new Date).getFullYear() - 1
  yearToRemove: number | null = null

  get yearToRemoveItems () {
    const items = []
    for (const year of this.years) {
      items.push({
        text: year.toString(),
        value: year
      })
    }
    return items
  }

  mounted () {
    let yearToAdd
    if (this.years.length === 0) {
      const thisYear = new Date().getFullYear()
      yearToAdd = thisYear
    }
    else {
      yearToAdd = this.biggestYear + 1
    }
    this.yearToAdd = yearToAdd
  }

  yearToAddRules = [
    (year: number) => !this.years.includes(year) || `Năm ${year} đã có rồi.`,
    (year: number) => {
      if (this.years.length === 0) {
        return true
      }
      else {
        return (
          this.smallestYear - 1 <= year &&
          this.biggestYear + 1 >= year
        ) || `Không thể thêm năm ${year}.`
      }
    },
  ]

  addYear () {
    // @ts-expect-error
    if (!this.$refs.addYearForm.validate()) return
    this.addYearMenu = false
    const newFinanceInfo = getNewFinanceInfo(this.company.id, this.yearToAdd)

    if (this.yearToAdd === this.biggestYear + 1 || this.years.length === 0) {
      // Dữ liệu năm sau thường gần giống năm trước => điền sẵn cho người dùng
      if (this.years.length > 0) {
        this.copyFinanceInfo(this.biggestYear, newFinanceInfo)
      }
      this.financeInfos.push(newFinanceInfo)
    }
    else if (this.yearToAdd === this.smallestYear - 1) {
      this.copyFinanceInfo(this.smallestYear, newFinanceInfo)
      this.financeInfos.splice(0, 0, newFinanceInfo)
    }
  }

  removeYear () {
    this.removeYearMenu = false

    for (let index = 0; index < this.financeInfos.length; index ++) {
      const info = this.financeInfos[index]
      if (info.year === this.yearToRemove) {
        this.financeInfos.splice(index, 1)
        this.$emit('finance-info-deleted', info.id)
        return
      }
    }
  }

  copyFinanceInfo (year: number, targetInfo: FinanceInfo) {
    const lastFinanceInfo = this.financeInfos.find(info => info.year === year)
    if (lastFinanceInfo !== undefined) {
      for (const [key, value] of Object.entries(lastFinanceInfo)) {
        if (['id', 'year', 'created_at', 'updated_at'].includes(key)) {
          continue
        }
        targetInfo[key] = value
      }
    }
  }

  @Watch('years')
  onYearsChange (years: Array<number>) {
    const biggestYear = Math.max(...years)
    const smallestYear = Math.min(...years)
    this.year = biggestYear
    if (biggestYear !== -Infinity && smallestYear !== Infinity) {
      this.yearToAdd = biggestYear + 1
      this.yearToRemove = smallestYear
    }
  }

  get smallestYear () {
    return Math.min(...this.years)
  }

  get biggestYear () {
    return Math.max(...this.years)
  }

  get tab () {
    return this.year - this.smallestYear
  }
  set tab (val) {
    this.year = val + this.smallestYear
  }

  companyCategories = [
    { text: 'A', value: 'A' },
    { text: 'B', value: 'B' },
    { text: 'C', value: 'C' },
  ]
  managerCategories = [
    { text: 'A', value: 'A' },
    { text: 'B', value: 'B' },
    { text: 'C', value: 'C' },
  ]
}
